import React from 'react'
import Style from '../Auth.module.css'
import { useForm } from "react-hook-form";
import Button from '../../../Components/Button/Button';
import Input from '../../../Components/Input/Input'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignInAlt } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
const Login = () => {
    const history=useHistory()
    const { register, handleSubmit, formState: { errors } } = useForm();
    const onSubmit = (data)=>{
        history.push('./confirm',data)
    };
    return (
        <div className={`pageHolder ${Style.LoginPageHolder}`}>
            <form onSubmit={handleSubmit(onSubmit)} className='formHolder'>
                <img className={Style.ImageHolder} src="/Assets/Images/Regular/Logo.png" alt="ElectronicSteps" />
                <label htmlFor="loginPart" > :برای ورود شماره همراه خود را وارد کنید <FontAwesomeIcon icon={faSignInAlt}/></label>
                <Input 
                id='loginPart' 
                {...register("phoneNumber", { required: true })} 
                maxLength='11' type={'tel'} 
                inputtype={errors.phoneNumber ? "valid" : "text"}
                style={{textAlign:'center'}}
                /> 
                <Button Value='ورود' ClassBtn={'confirmBtn'}/>

                <p className={Style.ChangeAuth}>هنوز ثبت نام نکرده اید؟ <Link to={'/register'}>ثبت نام</Link></p>
            </form>
        </div>
    )
}

export default Login
